var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 17,
    viewBox: "0 0 24 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_89_1877)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0.538452H24V16.3359H0V0.538452Z",
    fill: "#FDDA25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0.538452H8V16.3359H0V0.538452Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 0.538452H24V16.3359H16V0.538452Z",
    fill: "#EF3340"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_89_1877"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 15.7975,
    fill: "white",
    transform: "translate(0 0.538452)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBe);
export default __webpack_public_path__ + "static/media/BE.828ef8ff855f32abe90abe486a62a029.svg";
export { ForwardRef as ReactComponent };